import { Table } from '@tanstack/react-table';
import { Input } from '@zond/ui';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export default function DataTableToolbar<TData>({ table }: DataTableToolbarProps<TData>) {
  const { t } = useTranslation('alerts');
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder={t('toolbar.filterPlaceholder')}
          value={(table.getColumn('name')?.getFilterValue() as string) ?? ''}
          onChange={(event) => table.getColumn('name')?.setFilterValue(event.target.value)}
          className="h-8 w-[150px] lg:w-[250px]"
        />
        {isFiltered && (
          <button
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3 border border-input bg-transparent hover:bg-accent hover:text-accent-foreground rounded-md"
          >
            {t('common:actions.reset')}
            <X className="ml-2 h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
